import { RequestHeader } from '~/common/types';

export class CsrfHelper {
  public getCsrfHeader(): RequestHeader {
    const headers: RequestHeader = {};
    const header = document.head.querySelector('[name=_csrf_header]');
    const value = document.head.querySelector('[name=_csrf]');
    if (header === null || value === null) {
      return headers;
    }

    const name = header.getAttribute('content');
    if (name !== null) {
      headers[name] = value.getAttribute('content');
    }

    return headers;
  }
}
